module.exports = __webpack_public_path__ + "static/media/sprite_ring-text-fresh.e560641e.svg";